import createApiAuthClient, {
  type TApiAuthClientInstance,
  type TApiAuthClientProps,
  type ApiClientOptions,
} from './api-auth-client/api-auth-client';

export { createApiAuthClient, type TApiAuthClientProps, type TApiAuthClientInstance, type ApiClientOptions };
export default createApiAuthClient;
